const roundTZS = (number: any) => {
  if (number === undefined) {
    return 0;
  }
  let num = Math.round(number / 10000) * 10000;
  return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export default roundTZS;
